const inputPasswordToggleSkin = {
  inputWrapper: {
    position: "relative",
  },
  styledInput: {
    paddingRight: "30px",
  },
  showPasswordButton: {
    position: "absolute",
    top: "50%",
    right: "5px",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "var(--gc-default-text-color)",
  },
};

export default inputPasswordToggleSkin;
